////import 'core-js/stable';
////import 'regenerator-runtime/runtime';

////import '@babel/polyfill';
import $ from 'jquery'; // required for bootstrap dropdown which appears on the location modal on every page
//import 'url-search-params-polyfill'; // used on the search page

//// bootstrap plugins
import 'bootstrap/js/dist/util'; //todo
import 'bootstrap/js/dist/alert'; //todo
import 'bootstrap/js/dist/collapse'; //todo
import 'bootstrap/js/dist/dropdown'; // required for bootstrap dropdown which appears on the location modal on every page
import 'bootstrap/js/dist/tab'; //todo
import 'bootstrap/js/dist/tooltip'; //todo

import Common from './base/common'; // used on every page
//import Validation from './base/validation'; // used on the sign in page
import Layout from './base/layout'; // used on every page
//import Hero from './components/hero';  // used on Home, Category Overview, SOTALanding
//import Accordion from './components/accordion'; // used on Pagebuilder Widgets, SOTAMSAS, SOTAStates //todo
//import Tabs from './components/tabs'; // used on TabbedPageBuilder, Anti-Vaping Personalized Guide //todo
//import Carousel from './components/carousel'; // used on GetInvolved, Carousel Pagebuilder Widget, SOTALanding // todo
import Modal from './components/modal'; // used on every page
import Banner from './components/banner'; // used on every page
import Minimenus from './components/minimenus'; //appears on all pages / layout
//import Home from './pages/home';  // used on the Home page
//import PageBuilder from './components/pagebuilder';
//import FormTools from './utils/formTools'; //required for form builder
//import StateSelect from './components/state-variable-select';  // used on SOLCLanding, SOTCHighlights, SOTCLanding, SOTCState, DiseaseLanding
import Newsletter from './components/newsletter'; // used on every page
//import SearchPage from './pages/search'; // used on the search page
//import TrendReports from './pages/trendreports'; // used on the trend reports page
import './common/components/webpimages'; // used on every page
import './common/components/lazyload'; // used on every page

//window.FormTools = new FormTools(); // required for form builder
//window.Carousel = Carousel; // required for pagebuilder

$(() => {
    const common = new Common(); // appears on layout
	common.init();

	//const validation = new Validation();  // used on the sign in page
	//validation.init();  // used on the sign in page

    const layout = new Layout(); // appears on layout
	layout.init();

	//const carousel = new Carousel(); // used on GetInvolved, Carousel Pagebuilder Widget, SOTALanding // todo
	//carousel.initPageBuilder();

	//const hero = new Hero(); // used on Home, Category Overview, SOTALanding
	//hero.init(); // used on Home, Category Overview, SOTALanding

    //const accordion = new Accordion(); //todo
    //accordion.init();

    //const tabs = new Tabs(); //todo
    //tabs.init();

    const modal = new Modal(); // appears on layout
    modal.init();

    const banner = new Banner(); // appears on layout
    banner.init();

    const minimenus = new Minimenus(); // appears on all pages / layout
    minimenus.init();

    //if ($('.hero--home').length) {  // used on the home page
    //    const home = new home();   // used on the home page
    //    home.init();  // used on the home page
    //}  // used on the home page

    //const pagebuilder = new PageBuilder(); //todo
    //pagebuilder.init();

    const newsletter = new Newsletter(); // appears on layout
    newsletter.init();

    //const searchPage = new SearchPage();  // used on the search page
    //searchPage.init();  // used on the search page

    //const stateSelect = new StateSelect(); // used on SOLCLanding, SOTCHighlights, SOTCLanding, SOTCState, DiseaseLanding
	//stateSelect.init();

	//const trendreports = new TrendReports(); // used on the trend reports page
	//trendreports.init(); // used on the trend reports page

    //window.FormTools.init(); // used on formbuilder pages
});
